var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Title'),_c('Intro'),_c('Chancellor'),_c('PartOfGov'),_c('Coalition'),_c('Forecast'),_c('Events')],1)}
var staticRenderFns = []

export { render, staticRenderFns }